import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Calculator } from "@/components/Calculator";
import { Reviews } from "@/components/Reviews";
import { About } from "@/components/About";
import { Footer } from "@/components/Footer";
import { BookingModal } from "@/components/BookingModal";
import { scrollToId } from "@/lib/api";

export default function Home() {
  const [booking, setBooking] = useState({ open: false, prefill: null });
  const openBooking = (prefill = null) => setBooking({ open: true, prefill });
  const location = useLocation();

  useEffect(() => {
    if (location.state?.openBooking) openBooking(location.state.prefill || null);
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToId(location.state.scrollTo), 500);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <div data-testid="home-page">
      <Navbar onBook={openBooking} />
      <Hero onBook={openBooking} />
      <Marquee />
      <Services onBook={openBooking} />
      <Calculator onBook={openBooking} />
      <Reviews />
      <About />
      <Footer onBook={openBooking} />
      <BookingModal
        open={booking.open}
        prefill={booking.prefill}
        onClose={() => setBooking({ open: false, prefill: null })}
      />
    </div>
  );
}
